export enum CancelBookingStatuses {
  Cancelled,
  MemberIdIsEmpty,
  MemberPnoCantBeParsedToValidSpin,
  CouldNotFetchBooking,
  BookingWithUnCancelableStatus,
  BookingTimeSlotInvalid,
  BookingStartTimeTooClose,
  CouldNotFetchCustomerRegistration,
  CustomerDoesNotAllowCancellation,
  FailedToCancelBooking,
  FailedToCancelBookingWithException,
  CouldNotFetchMinCancelationTime,
}
